import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { history } from '../../../_helpers/history';
import { alertActions } from '../../../_actions/alert.actions';
import { Form, Button, Jumbotron, Spinner } from 'react-bootstrap';
import { vaccineVaccinationsService } from '../../../_services/vaccine-vaccinations.service';
import DateOfBirthInput from '../../../stories/Inputs/DateOfBirthInput';
import GenderInput from '../../../stories/Inputs/GenderInput';
import NumberInput from '../../../stories/Inputs/NumberInput';
import TextInput from '../../../stories/Inputs/TextInput';
import moment from 'moment';
import SelectInput from '../../../stories/Inputs/SelectInput';

class VaccinationEdit extends Component {
  constructor(props) {
    super(props)

    this.state = {
      errors: [],
      loading: false,
      pageLoading: false,
      id: '',
      city: '',
      race: '',
      title: '',
      gender: '',
      zipCode: '',
      vaccine: '',
      bodySite: '',
      lastName: '',
      firstName: '',
      lotNumber: '',
      ethnicity: '',
      occupation: '',
      dateOfBirth: '',
      mothersFirstName: '',
      vaccineEligibility: '',
      vaccinatorFullName: '',
    }

    this.vaccineEligibilityOptions = [
      { value: "V01", label: "Not VFC eligible" },
      { value: "V02", label: "VFC eligible-Medicaid/Medicaid Managed Care" },
      { value: "V03", label: "VFC eligible-Uninsured" },
      { value: "V04", label: "VFC eligible-American Indian/Alaskan Native" },
      { value: "V05", label: "VFC eligible-Federally Qualified Health Center Patient (under-insured)" },
      { value: "V06", label: "VFC eligible-State specific eligibility (e.g. S-CHIP plan)" },
      { value: "V07", label: "VFC eligibility-Local-specific eligibility" },
      { value: "V08", label: "Not VFC eligible-Under-insured" },
    ];

    this.bodySiteOptions = [
      { value: "BE", label: "Bilateral Ears" },
      { value: "BN", label: "Bilateral Nares" },
      { value: "BU", label: "Buttock" },
      { value: "CT", label: "Chest Tube" },
      { value: "LA", label: "Left Arm" },
      { value: "LAC", label: "Left Anterior Chest" },
      { value: "LACF", label: "Left Antecubital Fossa" },
      { value: "LD", label: "Left Deltoid" },
      { value: "LE", label: "Left Ear" },
      { value: "LEJ", label: "Left External Jugular" },
      { value: "LF", label: "Left Foot" },
      { value: "LG", label: "Left Gluteus Medius" },
      { value: "LH", label: "Left Hand" },
      { value: "LIJ", label: "Left Internal Jugular" },
      { value: "LLAQ", label: "Left Lower Abd Quadrant" },
      { value: "LLFA", label: "Left Lower Forearm" },
      { value: "LMFA", label: "Left Mid Forearm" },
      { value: "LN", label: "Left Naris" },
      { value: "LPC", label: "Left Posterior Chest" },
      { value: "LSC", label: "Left Subclavian" },
      { value: "LT", label: "Left Thigh" },
      { value: "LUA", label: "Left Upper Arm" },
      { value: "LUAQ", label: "Left Upper Abd Quadrant" },
      { value: "LUFA", label: "Left Upper Forearm" },
      { value: "LVG", label: "Left Ventragluteal" },
      { value: "LVL", label: "Left Vastus Lateralis" },
      { value: "NB", label: "Nebulized" },
      { value: "OD", label: "Right Eye" },
      { value: "OS", label: "Left Eye" },
      { value: "OU", label: "Bilateral Eyes" },
      { value: "PA", label: "Perianal" },
      { value: "PERIN", label: "Perineal" },
      { value: "RA", label: "Right Arm" },
      { value: "RAC", label: "Right Anterior Chest" },
      { value: "RACF", label: "Right Antecubital Fossa" },
      { value: "RD", label: "Right Deltoid" },
      { value: "RE", label: "Right Ear" },
      { value: "REJ", label: "Right External Jugular" },
      { value: "RF", label: "Right Foot" },
      { value: "RG", label: "Right Gluteus Medius" },
      { value: "RH", label: "Right Hand" },
      { value: "RIJ", label: "Right Internal Jugular" },
      { value: "RLAQ", label: "Rt Lower Abd Quadrant" },
      { value: "RLFA", label: "Right Lower Forearm" },
      { value: "RMFA", label: "Right Mid Forearm" },
      { value: "RN", label: "Right Naris" },
      { value: "RPC", label: "Right Posterior Chest" },
      { value: "RSC", label: "Right Subclavian" },
      { value: "RT", label: "Right Thigh" },
      { value: "RUA", label: "Right Upper Arm" },
      { value: "RUAQ", label: "Right Upper Abd Quadrant" },
      { value: "RUFA", label: "Right Upper Forearm" },
      { value: "RVG", label: "Right Ventragluteal" },
      { value: "RVL", label: "Right Vastus Lateralis" },
    ];
  }

  componentDidMount() {
    const id = this.props.match.params.id
    this.getVaccinationDetails(id);
  }

  getVaccinationDetails = (id) => {
    this.setState({ pageLoading: true });
    vaccineVaccinationsService.getDetails(id)
      .then(data => {
        this.setState(prevState => {
          return { ...prevState, ...data, dateOfBirth: data.dateOfBirth ? moment(data.dateOfBirth).format("MM/DD/YYYY") : "", pageLoading: false }
        })
      }).catch(() => {
        this.props.dispatch(alertActions.error('Could not view vaccination at this time. Please try again.'));
        this.setState({ pageLoading: false });
        history.push(`/vaccine/cair`);
      });
  }

  validate = () => {
    const errors = {};

    if (!this.state.zipCode) {
      errors.zipCode = "Zip code is required."
    }
    if (!this.state.city) {
      errors.city = "City is required."
    }
    if (!this.state.race) {
      errors.race = "Race is required."
    }
    if (!this.state.bodySite) {
      errors.bodySite = "Body Site is required."
    }
    if (!this.bodySiteOptions.find((bodySite) => bodySite.value === this.state.bodySite)) {
      errors.bodySite = "Please select Body Site."
    }
    if (!this.state.lotNumber) {
      errors.lotNumber = "Lot Number is required."
    }
    if (!this.state.lastName) {
      errors.lastName = "Last Name is required."
    }
    if (!this.state.firstName) {
      errors.firstName = "First Name is required."
    }
    if (!this.state.vaccinatorFullName) {
      errors.vaccinatorFullName = "Vaccinator Full Name is required."
    }
    if (!this.state.title) {
      errors.title = "Title is required."
    }
    if (!this.state.gender) {
      errors.gender = "Gender is required."
    }
    if (!this.state.vaccine) {
      errors.vaccine = "Vaccine is required."
    }
    if (!this.state.ethnicity) {
      errors.ethnicity = "Ethnicity is required."
    }
    if (!this.state.occupation) {
      errors.occupation = "Occupation is required."
    }
    if (!this.state.vaccineEligibility) {
      errors.vaccineEligibility = "Vaccine Eligibility is required."
    }
    if (!this.vaccineEligibilityOptions.find((vEl) => vEl.value === this.state.vaccineEligibility)) {
      errors.vaccineEligibility = "Please select Vaccine Eligibility."
    }
    if (this.state.dateOfBirth.length === 0) {
      errors.dateOfBirth = "Date of Birth is required.";
    }
    else if (this.state.dateOfBirth.replace(/\D/g, "").length !== 8) {
      errors.dateOfBirth = "Invalid format ex. 03/15/1980.";
    }
    else if (!moment(this.state.dateOfBirth, "MM/DD/YYYY").isValid()) {
      errors.dateOfBirth = "Date of Birth is not valid.";
    }

    this.setState({ errors });

    if (
      !errors.city &&
      !errors.race &&
      !errors.title &&
      !errors.gender &&
      !errors.zipCode &&
      !errors.vaccine &&
      !errors.bodySite &&
      !errors.lastName &&
      !errors.firstName &&
      !errors.lotNumber &&
      !errors.ethnicity &&
      !errors.occupation &&
      !errors.dateOfBirth &&
      !errors.vaccineEligibility &&
      !errors.vaccinatorFullName
    ) {
      this.handleSubmit();
    }
  }

  handleSubmit = () => {
    const { id } = this.state;

    const data = {
      race: this.state.race,
      title: this.state.title,
      gender: this.state.gender,
      vaccine: this.state.vaccine,
      bodySite: this.state.bodySite,
      lastName: this.state.lastName,
      firstName: this.state.firstName,
      lotNumber: this.state.lotNumber,
      ethnicity: this.state.ethnicity,
      occupation: this.state.occupation,
      dateOfBirth: this.state.dateOfBirth,
      patientCity: this.state.city,
      patientZipCode: this.state.zipCode,
      mothersFirstName: this.state.mothersFirstName,
      vaccineEligibility: this.state.vaccineEligibility,
      vaccinatorFullName: this.state.vaccinatorFullName,
    }

    this.toggleLoading();

    vaccineVaccinationsService.update(id, data)
      .then(data => {
        this.toggleLoading();
        history.push(`/vaccine/cair`, { completed: true });

      })
      .catch(() => {
        this.toggleLoading();
        this.props.dispatch(alertActions.error('Could not update vaccination at this time. Please try again.'));
      }
      );
  }

  toggleLoading = () => {
    this.setState(prevState => { return { loading: !prevState.loading } });
  }

  handleSetState = (value) => {
    this.setState(value);
  }

  render() {
    const {
      city,
      race,
      title,
      errors,
      gender,
      loading,
      zipCode,
      vaccine,
      bodySite,
      lastName,
      firstName,
      lotNumber,
      ethnicity,
      occupation,
      dateOfBirth,
      mothersFirstName,
      vaccineEligibility,
      vaccinatorFullName,
    } = this.state;

    return <div className="mt-4">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item"><Link to="/vaccine/cair">CAIR</Link></li>
          <li className="breadcrumb-item active" aria-current="page">Edit</li>
        </ol>
      </nav>

      <div className="card axs-shadow">
        <div className="card-header">
          <h5>Edit CAIR</h5>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col">
              {this.state.pageLoading ?
                <Jumbotron className="text-center bg-white">
                  <div className="row">
                    <div className="col-auto offset-5">
                      <Spinner animation="border" />
                    </div>
                    <div className="col-auto">
                      <h3><b>Loading...</b></h3>
                    </div>
                  </div>
                </Jumbotron>
                :
                <Form>
                  <Form.Group>
                    <div className="row p-2">
                      <div className="col">
                        <TextInput
                          value={lastName}
                          label="Last Name:"
                          errors={errors}
                          setValue={this.handleSetState}
                          valueName="lastName"
                          placeholder="Last Name"
                          required
                        />
                      </div>
                      <div className="col">
                        <TextInput
                          value={firstName}
                          label="First Name:"
                          errors={errors}
                          setValue={this.handleSetState}
                          valueName="firstName"
                          placeholder="First Name"
                          required
                        />
                      </div>
                      <div className="col">
                        <DateOfBirthInput
                          errors={errors}
                          label="Date of Birth:"
                          dateOfBirth={dateOfBirth}
                          setDOB={this.handleSetState}
                          required
                        />
                      </div>
                      <div className="col">
                        <TextInput
                          value={mothersFirstName}
                          label="Mother's First Name:"
                          errors={errors}
                          setValue={this.handleSetState}
                          valueName="mothersFirstName"
                          placeholder="Mother's First Name"
                        />
                      </div>
                    </div>
                  </Form.Group>

                  <hr />

                  <Form.Group>
                    <div className="row p-2">
                      <div className="col-3">
                        <NumberInput
                          value={zipCode}
                          label="Patient's Zip Code:"
                          errors={errors}
                          setValue={this.handleSetState}
                          valueName="zipCode"
                          placeholder="Patient's Zip Code"
                          required
                        />
                      </div>
                      <div className="col-3">
                        <TextInput
                          value={city}
                          label="Patient's City:"
                          errors={errors}
                          setValue={this.handleSetState}
                          valueName="city"
                          placeholder="Patient's City"
                          required
                        />
                      </div>
                    </div>
                  </Form.Group>

                  <hr />

                  <Form.Group>
                    <div className="row p-2">
                      <div className="col">
                        <TextInput
                          value={race}
                          label="Race:"
                          errors={errors}
                          setValue={this.handleSetState}
                          valueName="race"
                          placeholder="Race"
                          required
                        />
                      </div>
                      <div className="col">
                        <GenderInput
                          value={gender}
                          errors={errors}
                          setValue={this.handleSetState}
                          genderOptions={[
                            { value: 'Male', label: 'Male' },
                            { value: 'Female', label: 'Female' },
                            { value: 'Other', label: 'Other' }
                          ]}
                          required
                        />
                      </div>
                      <div className="col">
                        <TextInput
                          value={ethnicity}
                          label="Ethnicity:"
                          errors={errors}
                          setValue={this.handleSetState}
                          valueName="ethnicity"
                          placeholder="Ethnicity"
                          required
                        />
                      </div>
                      <div className="col">
                        <TextInput
                          value={occupation}
                          label="Occupation:"
                          errors={errors}
                          setValue={this.handleSetState}
                          valueName="occupation"
                          placeholder="Occupation"
                          required
                        />
                      </div>
                    </div>
                  </Form.Group>

                  <hr />

                  <Form.Group>
                    <div className="row p-2">
                      <div className="col">
                        <SelectInput
                          value={vaccineEligibility}
                          label="Vaccine Eligibility:"
                          errors={errors}
                          options={this.vaccineEligibilityOptions}
                          setValue={this.handleSetState}
                          valueName="vaccineEligibility"
                          placeholder="Vaccine Eligibility"
                          required
                        />
                      </div>
                      <div className="col">
                        <TextInput
                          value={vaccine}
                          label="Vaccine:"
                          errors={errors}
                          setValue={this.handleSetState}
                          valueName="vaccine"
                          placeholder="Vaccine"
                          required
                        />
                      </div>
                      <div className="col">
                        <TextInput
                          value={lotNumber}
                          label="Lot Number:"
                          errors={errors}
                          setValue={this.handleSetState}
                          valueName="lotNumber"
                          placeholder="Lot Number"
                          required
                        />
                      </div>
                      <div className="col">
                        <SelectInput
                          value={bodySite}
                          label="Body Site:"
                          errors={errors}
                          options={this.bodySiteOptions}
                          setValue={this.handleSetState}
                          valueName="bodySite"
                          placeholder="Body Site"
                          required
                        />
                      </div>
                    </div>
                  </Form.Group>

                  <hr />

                  <Form.Group>
                    <div className="row p-2">
                      <div className="col-3">
                        <TextInput
                          value={vaccinatorFullName}
                          label="Vaccinator Full Name:"
                          errors={errors}
                          setValue={this.handleSetState}
                          valueName="vaccinatorFullName"
                          placeholder="Vaccinator Full Name"
                          required
                        />
                      </div>
                      <div className="col-3">
                        <TextInput
                          value={title}
                          label="Title:"
                          errors={errors}
                          setValue={this.handleSetState}
                          valueName="title"
                          placeholder="Title"
                          required
                        />
                      </div>
                    </div>
                  </Form.Group>
                </Form>
              }

              <hr />

              <div className="row p-2">
                <div className="col-2"><Link to="/vaccine/cair" className="btn btn-block btn-outline-primary">Cancel</Link></div>
                <div className="col-3"><Button variant="success" block onClick={this.validate}>
                  {loading ? <i className="fa fa-spinner fa-spin fa-fw"></i> : "Save"}</Button></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}

export default connect()(VaccinationEdit)